export const enviromentConfigs={
    // REACT_APP_API_URL:"http://localhost:3001/",
    REACT_APP_API_URL:"https://knightbe.cloudjiffy.net/",
    // REACT_APP_API_KEY=your-api-key
}